<template>
  <div>
    <input type="file" ref="fileInput" style="display: none" @change="onFileSelected" />

    <b-button
      @click="openFileDialog"
      @mouseenter="isHoveringAttachment = true"
      @mouseleave="isHoveringAttachment = false"
      variant="outline-dark"
    >
      <img v-if="isHoveringAttachment" src="@/assets/icons/attach-active.svg" width="15" height="15" class="mr-2" />
      <img v-else src="@/assets/icons/attach.svg" width="15" height="15" class="mr-2" />
      <small>Add attachment</small>
    </b-button>

    <div>
      <div v-if="isUploading">
        <em>Uploading file...</em>
      </div>

      <h6 v-if="isShowingTitle && localAttachments.length" class="mt-4 w-100 text-uppercase font-poppins">Attachments</h6>

      <div v-for="(f, index) in localAttachments" :key="f.id" class="mt-3 p-2 bg-white rounded">
        <img
          @click="triggerRemoveFile({ ...f, index })"
          src="@/assets/icons/trash.svg"
          width="15"
          height="15"
          class="mt-2 mr-2 float-right cursor-pointer"
        />

        <img src="@/assets/icons/file.svg" width="30" class="mr-3" />

        <small class="font-weight-bold">
          {{ f.name }}
        </small>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { UPLOAD, REMOVE } from "@/store/actions";

import { BButton } from "bootstrap-vue";

export default {
  name: "Attachments",
  components: { BButton },
  props: {
    attachments: {
      type: Array,
      default: () => [],
    },
    isShowingTitle: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    projectId() {
      return this.$route.params.projectId;
    },
  },
  data: () => ({
    localAttachments: [],

    isSuccess: false,
    isUploading: false,
    isHoveringAttachment: false,
  }),
  created() {
    this.localAttachments = [...this.attachments];
    this.$watch("localAttachments", (newValue) => { this.$emit("update:attachments", newValue); }, { deep: true }); /* prettier-ignore */
  },
  methods: {
    ...mapActions("storage", { uploadFile: UPLOAD, removeFile: REMOVE }),
    async handleUpload(file) {
      const { projectId, stateCallback, errorCallback } = this;

      this.isUploading = true;

      const { isSuccess, id, name, url } = await this.uploadFile({
        projectId,
        file,
        stateCallback,
        errorCallback,
        uploadedCallback: () => {},
      });

      if (isSuccess) {
        this.localAttachments.push({ id, name, url });

        this.isSuccess = isSuccess;
        this.isUploading = false;

        this.$emit("success", { id, name, url });
      }
    },
    stateCallback(snapshot) {
      this.progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
    },
    errorCallback(message) {
      this.isUploading = false;
      this.errorMessage = message;
    },

    async triggerRemoveFile({ index, id }) {
      this.isSending = true;

      this.localAttachments.splice(index, 1);

      const { projectId } = this;
      await this.removeFile({ projectId, id });

      this.isSending = false;
    },

    openFileDialog() {
      this.$refs.fileInput.click();
    },

    onFileSelected(event) {
      const file = event.target.files[0];
      if (file) {
        this.handleUpload(file);
      }
    },
  },
};
</script>
